// assetNaming — pick a name that won't collide with existing live assets.
//
// The asset-manager enforces a partial-unique index on (character_id, name) for
// LIVE rows (deleted_at IS NULL — migration 00024). Creating a second asset
// with a default name (e.g. a 2nd "New Graph Material") otherwise fails with a
// raw Postgres 23505 "duplicate key" error surfaced to the user. Suffix
// " 2", " 3", … until free — the familiar "New Folder (2)" behaviour.
//
// Pure + dependency-free so it's trivially unit-testable.
export function uniqueAssetName(base, taken) {
  const set = taken instanceof Set ? taken : new Set(taken || [])
  if (!set.has(base)) return base
  for (let n = 2; ; n++) {
    const candidate = `${base} ${n}`
    if (!set.has(candidate)) return candidate
  }
}
